import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { useState } from 'react';

import { routeTree } from '../routeTree.gen';

export function createAppQueryClient() {
  return new QueryClient({
    // TanStack Query retries 3 times by default, which would retry a 403.
    defaultOptions: { queries: { retry: false } },
  });
}

export function createAppRouter(queryClient: QueryClient) {
  // The query client rides on the router context so route guards read the same
  // session cache the components do — one fetch, one answer.
  return createRouter({ routeTree, context: { queryClient } });
}

// Without this, `createFileRoute` and every loader silently degrade to `any`.
declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}

export function AppProviders() {
  // Created once per mount. Built inline, a re-render would replace the client
  // and the router together and remount the whole tree from scratch.
  const [queryClient] = useState(createAppQueryClient);
  const [router] = useState(() => createAppRouter(queryClient));

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
